[
  {
    "id": "swordsmanship",
    "name": "Swordsmanship",
    "description": "Skill with blades, from surviving ordinary melee encounters to challenging elite champions.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "dawnmere_guard_captain",
        "locationId": "dawnmere",
        "trainingDays": 2,
        "requirements": [],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": "ironwatch_swordmaster",
        "locationId": "ironwatch_fortress",
        "trainingDays": 4,
        "requirements": [
          "swordsmanship_beginner"
        ],
        "taskId": "defeat_three_soldiers",
        "testBattleId": "ironwatch_advanced_test",
        "blockedByFlags": [
          "ironwatch_swordmaster_dead"
        ]
      },
      {
        "level": "master",
        "teacherId": "ironwatch_swordmaster",
        "locationId": "ironwatch_fortress",
        "trainingDays": 7,
        "requirements": [
          "swordsmanship_advanced"
        ],
        "taskId": "duel_the_ironwatch_champion",
        "testBattleId": "ironwatch_master_test",
        "blockedByFlags": [
          "ironwatch_swordmaster_dead"
        ]
      }
    ]
  },
  {
    "id": "archery",
    "name": "Archery",
    "description": "Skill with the bow, from loosing a steady shot to placing one exactly where it is needed.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "ironwatch_quartermaster",
        "locationId": "ironwatch_fortress",
        "trainingDays": 2,
        "requirements": [],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": "ironwatch_quartermaster",
        "locationId": "ironwatch_fortress",
        "trainingDays": 4,
        "requirements": [
          "archery_beginner"
        ],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "master",
        "teacherId": "starbow_archmarshal",
        "locationId": "starbow_academy",
        "trainingDays": 6,
        "requirements": [
          "archery_advanced"
        ],
        "trustRequirement": {
          "factionId": "high_elves",
          "level": "recognized"
        },
        "taskId": null,
        "testBattleId": null
      }
    ]
  },
  {
    "id": "survival",
    "name": "Survival",
    "description": "The knowledge required to endure the wilderness and dangerous encounters.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": null,
        "locationId": null,
        "trainingDays": 1,
        "requirements": [],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": null,
        "locationId": null,
        "trainingDays": 3,
        "requirements": [
          "survival_beginner"
        ],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "master",
        "teacherId": null,
        "locationId": null,
        "trainingDays": 5,
        "requirements": [
          "survival_advanced"
        ],
        "taskId": null,
        "testBattleId": null
      }
    ]
  },
  {
    "id": "leadership",
    "name": "Leadership",
    "description": "The ability to command a force, from a small band to mixed-faction armies.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "dawnmere_guard_captain",
        "locationId": "dawnmere",
        "trainingDays": 2,
        "requirements": [],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": "ironwatch_swordmaster",
        "locationId": "ironwatch_fortress",
        "trainingDays": 4,
        "requirements": [
          "leadership_beginner"
        ],
        "taskId": null,
        "testBattleId": null,
        "blockedByFlags": [
          "ironwatch_swordmaster_dead"
        ]
      },
      {
        "level": "master",
        "teacherId": "ironwatch_swordmaster",
        "locationId": "ironwatch_fortress",
        "trainingDays": 6,
        "requirements": [
          "leadership_advanced"
        ],
        "taskId": null,
        "testBattleId": null,
        "blockedByFlags": [
          "ironwatch_swordmaster_dead"
        ]
      }
    ]
  },
  {
    "id": "diplomacy",
    "name": "Diplomacy",
    "description": "The art of being heard, from obtaining an audience to negotiating the support of whole factions.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "crownreach_court_chamberlain",
        "locationId": "crownreach",
        "trainingDays": 2,
        "requirements": [],
        "taskId": null,
        "testBattleId": null,
        "blockedByFlags": [
          "crownreach_chamberlain_dead"
        ]
      },
      {
        "level": "advanced",
        "teacherId": "crownreach_court_chamberlain",
        "locationId": "crownreach",
        "trainingDays": 4,
        "requirements": [
          "diplomacy_beginner"
        ],
        "taskId": null,
        "testBattleId": null,
        "blockedByFlags": [
          "crownreach_chamberlain_dead"
        ]
      },
      {
        "level": "master",
        "teacherId": "crownreach_court_chamberlain",
        "locationId": "crownreach",
        "trainingDays": 6,
        "requirements": [
          "diplomacy_advanced"
        ],
        "taskId": null,
        "testBattleId": null,
        "blockedByFlags": [
          "crownreach_chamberlain_dead"
        ]
      }
    ]
  },
  {
    "id": "riding",
    "name": "Riding",
    "description": "Horsemanship, from staying in the saddle to riding as though born to it. A trained rider covers ground in fewer days — advanced and master shorten every multi-day leg of travel.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "rivergate_stablemaster",
        "locationId": "rivergate",
        "trainingDays": 2,
        "requirements": [],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": "rivergate_stablemaster",
        "locationId": "rivergate",
        "trainingDays": 4,
        "requirements": [
          "riding_beginner"
        ],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "master",
        "teacherId": "rivergate_stablemaster",
        "locationId": "rivergate",
        "trainingDays": 6,
        "requirements": [
          "riding_advanced"
        ],
        "taskId": null,
        "testBattleId": null
      }
    ]
  },
  {
    "id": "history",
    "name": "History",
    "description": "Knowledge of the kingdom's past, from understanding recent disputes to resolving conflicts centuries old.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "crownreach_royal_historian",
        "locationId": "crownreach",
        "trainingDays": 2,
        "requirements": [],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": "crownreach_royal_historian",
        "locationId": "crownreach",
        "trainingDays": 4,
        "requirements": [
          "history_beginner"
        ],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "master",
        "teacherId": "crownreach_royal_historian",
        "locationId": "crownreach",
        "trainingDays": 6,
        "requirements": [
          "history_advanced"
        ],
        "taskId": null,
        "testBattleId": null
      }
    ]
  },
  {
    "id": "healing",
    "name": "Healing",
    "description": "The physician's craft, from binding wounds to treating what would otherwise be beyond saving.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "rivergate_physician",
        "locationId": "rivergate",
        "trainingDays": 2,
        "requirements": [],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": "rivergate_physician",
        "locationId": "rivergate",
        "trainingDays": 4,
        "requirements": [
          "healing_beginner"
        ],
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "master",
        "teacherId": "rivergate_physician",
        "locationId": "rivergate",
        "trainingDays": 6,
        "requirements": [
          "healing_advanced"
        ],
        "taskId": null,
        "testBattleId": null
      }
    ]
  },
  {
    "id": "siegecraft",
    "name": "Siegecraft",
    "description": "The dwarven art of breaking walls and the things that stand like walls. Your whole line deals heavier damage to fortifications and to the giants who fight like them.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "stonehall_masterwright",
        "locationId": "stonehall",
        "trainingDays": 2,
        "requirements": [],
        "trustRequirement": { "factionId": "dwarves", "level": "recognized" },
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": "stonehall_masterwright",
        "locationId": "stonehall",
        "trainingDays": 4,
        "requirements": ["siegecraft_beginner"],
        "trustRequirement": { "factionId": "dwarves", "level": "trusted" },
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "master",
        "teacherId": "stonehall_masterwright",
        "locationId": "stonehall",
        "trainingDays": 6,
        "requirements": ["siegecraft_advanced"],
        "trustRequirement": { "factionId": "dwarves", "level": "subjected" },
        "taskId": null,
        "testBattleId": null
      }
    ]
  },
  {
    "id": "tracking",
    "name": "Tracking",
    "description": "The Wood Elf craft of reading a trail nothing wants read. From advanced on, enemy ambushers who would open from concealment — Dark Elves and worse — are already in the open when battle is joined.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "greenveil_trailwarden",
        "locationId": "greenveil",
        "trainingDays": 2,
        "requirements": [],
        "trustRequirement": { "factionId": "wood_elves", "level": "recognized" },
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": "greenveil_trailwarden",
        "locationId": "greenveil",
        "trainingDays": 4,
        "requirements": ["tracking_beginner"],
        "trustRequirement": { "factionId": "wood_elves", "level": "trusted" },
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "master",
        "teacherId": "greenveil_trailwarden",
        "locationId": "greenveil",
        "trainingDays": 6,
        "requirements": ["tracking_advanced"],
        "trustRequirement": { "factionId": "wood_elves", "level": "subjected" },
        "taskId": null,
        "testBattleId": null
      }
    ]
  },
  {
    "id": "arcana",
    "name": "Arcana",
    "description": "The Spellcasters' discipline of bindings and their unmaking. Your arcane casters — ritual mages, storm callers — strike harder, their banishments of anchors and demons most of all.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "sevenfold_lorekeeper",
        "locationId": "sevenfold_tower",
        "trainingDays": 2,
        "requirements": [],
        "trustRequirement": { "factionId": "spellcasters", "level": "recognized" },
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": "sevenfold_lorekeeper",
        "locationId": "sevenfold_tower",
        "trainingDays": 4,
        "requirements": ["arcana_beginner"],
        "trustRequirement": { "factionId": "spellcasters", "level": "trusted" },
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "master",
        "teacherId": "sevenfold_lorekeeper",
        "locationId": "sevenfold_tower",
        "trainingDays": 6,
        "requirements": ["arcana_advanced"],
        "trustRequirement": { "factionId": "spellcasters", "level": "subjected" },
        "taskId": null,
        "testBattleId": null
      }
    ]
  },
  {
    "id": "spirit_lore",
    "name": "Spirit Lore",
    "description": "The Good Spirits' knowledge of the dead and the possessed. Your holy troops — spirit wardens, the radiant seraph — strike harder, laying the Necromancer's undead to rest rather than merely cutting them down.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "whispering_lake_pale_sister",
        "locationId": "whispering_lake",
        "trainingDays": 2,
        "requirements": [],
        "trustRequirement": { "factionId": "good_spirits", "level": "recognized" },
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": "whispering_lake_pale_sister",
        "locationId": "whispering_lake",
        "trainingDays": 4,
        "requirements": ["spirit_lore_beginner"],
        "trustRequirement": { "factionId": "good_spirits", "level": "trusted" },
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "master",
        "teacherId": "whispering_lake_pale_sister",
        "locationId": "whispering_lake",
        "trainingDays": 6,
        "requirements": ["spirit_lore_advanced"],
        "trustRequirement": { "factionId": "good_spirits", "level": "subjected" },
        "taskId": null,
        "testBattleId": null
      }
    ]
  },
  {
    "id": "horsemastery",
    "name": "Horsemastery",
    "description": "The Nomad art of fighting from the saddle. Your mounted troops — lancers, horse archers, outriders — strike harder in every battle.",
    "levels": [
      {
        "level": "beginner",
        "teacherId": "camp_banner_rider",
        "locationId": "camp_seven_banners",
        "trainingDays": 2,
        "requirements": [],
        "trustRequirement": { "factionId": "nomads", "level": "recognized" },
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "advanced",
        "teacherId": "camp_banner_rider",
        "locationId": "camp_seven_banners",
        "trainingDays": 4,
        "requirements": ["horsemastery_beginner"],
        "trustRequirement": { "factionId": "nomads", "level": "trusted" },
        "taskId": null,
        "testBattleId": null
      },
      {
        "level": "master",
        "teacherId": "camp_banner_rider",
        "locationId": "camp_seven_banners",
        "trainingDays": 6,
        "requirements": ["horsemastery_advanced"],
        "trustRequirement": { "factionId": "nomads", "level": "subjected" },
        "taskId": null,
        "testBattleId": null
      }
    ]
  }
]
